import React from "react";

import { Link } from "react-router-dom";

const CheckedIDLink = ({ allRooms, roomIDToCheck, errorText }) => {
  const potentialURL = "/room/" + roomIDToCheck;

  function getRoomNameFromRoomID() {
    for (let i = 0; i < allRooms.length; i++) {
      if (allRooms[i].roomID === roomIDToCheck) {
        return allRooms[i].room;
      }
    }
  }

  return (
    <>
      {
        /* Checks if dataset exists and if the dataset contains an entry for the specific roomID */
        // Does contain: Returns the Link element for routing
        // Does NOT contain: Specify an element
      }
      {allRooms && allRooms.some((item) => item.roomID === roomIDToCheck) ? (
        <Link to={potentialURL}>{getRoomNameFromRoomID()}</Link>
      ) : (
        errorText
      )}
    </>
  );
};

export default CheckedIDLink;
